export default __webpack_public_path__ + "static/media/logo_evora.3ec87347.png";